export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_COACH_WEB_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_COACH_WEB_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_COACH_WEB_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_COACH_WEB_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_COACH_WEB_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_COACH_WEB_FIREBASE_MSG_SENDER_ID,
  appId: process.env.REACT_APP_COACH_WEB_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_COACH_WEB_FIREBASE_MEASUREMENT_ID,
};
export const DEFAULT_CURRENCY = 'USD'